import { render, staticRenderFns } from "./OrganigramaMuni.vue?vue&type=template&id=50b65011&scoped=true&"
import script from "./OrganigramaMuni.vue?vue&type=script&lang=ts&"
export * from "./OrganigramaMuni.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b65011",
  null
  
)

export default component.exports